import {UntilDestroy} from '@ngneat/until-destroy';
import {Injectable} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {EddlAdobeTrackingData, SUPPORT_FORM_NAME} from './models/eddl-adobe-tracking-data';
import {CxEvent, EventService, Product} from '@spartacus/core';
import {FormUuidService} from '../form-uuid.service';
import {EddlFormViewEvent} from './events/eddl-form-view-event';

export const LEAD_FORM_ACTION_TYPE: string = 'popup';
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DcpEddlFormViewService extends DcpDataService<EddlAdobeTrackingData> {
  constructor(protected formUuidService: FormUuidService, protected eventService: EventService) {
    super();
  }

  fillData(event: EddlFormViewEvent, data?: EddlAdobeTrackingData): EddlAdobeTrackingData {
    if (!data) {
      data = {};
    }
    if (!data.forms) {
      data.forms = {};
    }
    data.event = 'formView';
    data.forms.name = event.name;

    data.forms.uniqueID =
      event.name === SUPPORT_FORM_NAME
        ? this.formUuidService.getSupportFormUuid()
        : this.formUuidService.getTrimmedUuidByFormName(event.name);

    data.forms.referrer = window.location.href;

    if (!data.ecommerce && event.products?.length > 0) {
      data.ecommerce = {};
      data.ecommerce.products = [];

      data.ecommerce.products.push({
        id: event?.products?.[0]?.ID,
        name: event?.products?.[0]?.name,
        partnerName: event?.products?.[0]?.partnerName,
      });
    }
    return data;
  }

  getData(event: CxEvent): EddlAdobeTrackingData {
    if (!(event instanceof EddlFormViewEvent)) {
      return undefined;
    }
    return this.fillData(event);
  }

   /**
     * Sends lead form view EDDL event data to adobe analytics.
     * Only dispatches the event when the {@code actionType} equals 'popup'.
     */
    public triggerEddlFormViewEvent(actionType: string, name: string, product: Product, productId: string) {
      if (actionType === LEAD_FORM_ACTION_TYPE) {
        const event = new EddlFormViewEvent();
        event.name = name;
        if (product) {
          event.products = [];
          event.products.push({
            ID: productId,
            name: product?.name || '',
            partnerName: product?.vendor?.name || '',
          });
        }
        setTimeout(() => this.eventService.dispatch(event));
      }
    }
}
